module.exports = __webpack_public_path__ + "img/monbaceco3.c8608d90.png";